import { memoize } from 'utils/misc'
import { IStorageClassSelector } from './model'
import { propEq } from 'ramda'

export const isDefaultStorageClass = (storageClass: Partial<IStorageClassSelector>) =>
  storageClass?.metadata?.annotations?.['storageclass.kubernetes.io/is-default-class'] === 'true'

export const getSelectedCluster = memoize((clusters, id) => clusters.find(propEq('uuid', id)))
